// 1. Tell the browser NOT to restore scroll position automatically
if (history.scrollRestoration) {
  history.scrollRestoration = 'manual';
}
// 2. Wait for the window to fully load (images, CSS, everything)
//    and then force the scroll to the anchor if one exists.
window.addEventListener('DOMContentLoaded', function() {
  var fullHash = window.location.hash; // Gets: #div1?utm_source=...

  // Check if there is an anchor fragment
  if (fullHash && fullHash !== '#') {

    // --- NEW LOGIC: Isolate the actual ID ---
    // Find the index of the question mark, or use the end of the string
    var qMarkIndex = fullHash.indexOf('?');
    var cleanHash = (qMarkIndex !== -1) ? fullHash.substring(0, qMarkIndex) : fullHash;

    // Strip the leading '#' to get the pure ID (e.g., "div1")
    var targetId = cleanHash.substring(1);
    // ----------------------------------------

    var targetElement = document.getElementById(targetId);

    if (targetElement) {
      // Use a tiny timeout to ensure the scroll runs last
      setTimeout(function() {
        window.scrollTo({
          top: targetElement.offsetTop,
          behavior: 'instant' // Instant scroll
        });
      }, 1);
    }
  }
});
